import { FileConversionService, Select, UploadFile } from 'vopay';
import { useTranslation } from 'react-i18next';
import { FieldData } from '@/components/Form/types';
import * as Yup from 'yup';

export type ConvertMyTemplateFormValues = {
  Service: FileConversionService;
  FileBase64: string;
  FileName: string;
};

export const useConvertMyTemplateFormFields = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.FileUploadDrawer.ConvertTemplate' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const ServiceOptions = [
    { value: 'debit', label: tGlobal('ServiceOptions.debit') },
    { value: 'credit', label: tGlobal('ServiceOptions.credit') },
  ];

  const uploadFile: FieldData<ConvertMyTemplateFormValues>[] = [
    {
      fieldName: 'Service',
      label: () => t('serviceLabel', { defaultValue: 'Transfer Type' }),
      getInputState: () => 'required',
      showField: () => true,
      validate: () => Yup.string().required(),
      renderField: ({ getFormikData }) => (
        <Select
          version="2"
          {...getFormikData<ConvertMyTemplateFormValues['Service']>({})}
          options={ServiceOptions}
          placeholder=""
          sort={false}
        />
      ),
    },
    {
      fieldName: 'FileBase64',
      label: () => t('fileLabel', { defaultValue: 'Attachment' }),
      getInputState: () => 'required',
      showField: () => true,
      validate: () => Yup.string().required(),
      renderField: ({ getFormikData, ctx }) => {
        const data = getFormikData<ConvertMyTemplateFormValues['FileBase64']>({});
        return (
          <UploadFile
            id="FileBase64"
            {...data}
            variant="onboarding"
            onBlurFileName={(e: React.FocusEvent<HTMLInputElement>) => ctx.handleBlur(e)}
            onChangeFileName={(e: React.ChangeEvent<HTMLInputElement>) => ctx.setFieldValue('FileName', e.target.value)}
            idFileName="FileName"
            valueFileName={ctx.values.FileName}
            maxMBSize={20}
            keepExtension={true}
          />
        );
      },
    },
  ];

  return { uploadFile };
};
